import * as ACTION_TYPES from '../types';

let initialState = {
  roles: [],
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_ROLES_REQUEST:
      return { ...state, loading:true };
    case ACTION_TYPES.GET_ROLES_SUCCESS:
      return { ...state, roles: action.data, loading: false };
    case ACTION_TYPES.GET_ROLES_FAILED:
      return { ...state, loading: false };
    case ACTION_TYPES.RESET_ROLES:
      return { ...state, roles: [] };
    default:
      return state;
  }
};
